/* eslint-disable import/no-unresolved */
import styles from 'components/styles/main-menu.css'
import IconRemove from 'img/icons/icon-remove.png'
import IconMenu from 'img/icons/burger-menu.png'

const Hamburger = ({ isMainMenuOpen, onClick }) => {
  return (
    <div className={styles.mainMenuBurger} onClick={onClick}>
      <img
        src={isMainMenuOpen ? IconRemove : IconMenu}
        className={styles.mainMenuBurgerIcon}
      />
    </div>
  )
}

export default Hamburger
